import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';
import { LoadingStates } from '@tdp/common/constants';
import { IAppValidationItem, IAppValidationList } from '../abstractions/IAppValidation';
import { IPreValidation } from '../abstractions/IAppPreValidation';

interface IAppValidationState {
  appId: string | null;
  currentValidation: IAppValidationItem | null;
  count: number;
  validationList: IAppValidationList;
  loading: LoadingStates;
  preValidation: IPreValidation | undefined;
  newValidationId: string | null;
}

const initialState: IAppValidationState = {
  appId: null,
  currentValidation: null,
  count: 0,
  validationList: {
    appValidations: [],
    continuationToken: undefined,
  },
  loading: LoadingStates.NOT_STARTED,
  preValidation: undefined,
  newValidationId: null,
}

export const appValidationSlice = createSlice({
  name: "appValidation",
  initialState,
  reducers: {
    reset: (state) => {
      state = initialState
    },
    resetCurrentValidation: (state) => {
      state.currentValidation = null
    },
    resetNewValidationId: (state) => {
      state.newValidationId = null
    },
    setNewValidationId: (state, payloadAction: PayloadAction<string>) => {
      state.newValidationId = payloadAction.payload
    },
    setValidationAppId: (state, payloadAction: PayloadAction<string>) => {
      state.appId = payloadAction.payload
    },
    validationCountLoaded: (state, payloadAction: PayloadAction<number>) => {
      state.count = payloadAction.payload
    },
    getValidationListStart: (state) => {
      state.loading = LoadingStates.LOADING
    },
    getValidationListSuccess: (state, payloadAction: PayloadAction<IAppValidationList>) => {
      state.loading = LoadingStates.SUCCESS
      state.validationList = payloadAction.payload
    },
    getValidationListFailed: (state) => {
      state.loading = LoadingStates.ERROR
    },
    getValidationDetailListSuccess: (state, payloadAction: PayloadAction<IAppValidationItem>) => {
      state.loading = LoadingStates.SUCCESS
      state.currentValidation = payloadAction.payload
    },
    resetPreValidation: (state) => {
      state.preValidation = undefined
    },
    setPreValidation: (state, payloadAction: PayloadAction<IPreValidation>) => {
      state.preValidation = payloadAction.payload
    }
  },
  selectors: {
    loading: (s) => s.loading,
    validationCount: (s) => s.count,
    validationList: (s) => s.validationList,
    validationAppId: (s) => s.appId,
    currentValidation: (s) => s.currentValidation,
    preValidation: (s) => s.preValidation,
    newValidationId: (s) => s.newValidationId,
  }
});
